import { render } from "./BocalCalculatorComponent.vue?vue&type=template&id=4294f9c5&scoped=true"
import script from "./BocalCalculatorComponent.vue?vue&type=script&lang=js"
export * from "./BocalCalculatorComponent.vue?vue&type=script&lang=js"

import "./BocalCalculatorComponent.vue?vue&type=style&index=0&id=4294f9c5&scoped=true&lang=css"
import "./BocalCalculatorComponent.vue?vue&type=style&index=1&id=4294f9c5&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4294f9c5"]])

export default __exports__